
import Vue from "vue";

export default Vue.extend({
  components: {},
  name: "DropdownBuilder",
  props: {
    label: {
      type: String,
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    scoreLabel: {
      type: String,
      default: "",
    },
    score: {
      type: Boolean,
      default: false,
    },
    scores: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      list: this.value,
      scoreList: this.scores ? this.scores : this.value?.map(() => null)
    };
  },
  methods: {
    updateValue(value: any) {
      this.$emit("input", value);
    },
    deleteListElement(index: number) {
      this.list.splice(index, 1);
      this.scoreList.splice(index, 1);
    },
    addListElement() {
      this.list.push('');
      this.scoreList.push(null);
    },
    getColFlex(): number {
      if (!this.score) return 12;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
        default:
          return 12;
      }
    },
  },
  watch: {
    list: function (nList) {
      this.list = nList;
      this.$emit("input", nList);
    },
    scoreList: function (nList) {
      this.scoreList = nList;
      this.$emit("score", nList);
    },
  },
});
